module.exports = __webpack_public_path__ + "img/menu.073f1a99.svg";